import { Link } from 'react-router-dom';
import { MdKeyboardArrowRight } from "react-icons/md";

const PageHeading = ({ title, breadcrumbs }) => {
  return (
    <div className='block sm:flex items-center justify-between gap-9 mb-5 mt-1'>
      <h2 className='font-inter font-semibold text-lg text-[#4C4D5D]'>{title}</h2>
      <ul className='flex items-center flex-wrap gap-2'>
        {breadcrumbs.map((breadcrumb, index) => (
          <li
            key={index}
            className={`font-inter font-normal text-sm text-M-text-color relative flex items-center gap-1 ${
              index === breadcrumbs.length - 1 ? 'text-M-text-color/50' : ''
            }`}
          >
            {breadcrumb.url ? (
              <Link
                to={breadcrumb.url}
                className='hover:text-M-primary-color transition-all duration-200'
              >
                {breadcrumb.label}
              </Link>
            ) : (
              <span>{breadcrumb.label}</span>
            )}
            {index < breadcrumbs.length - 1 && <MdKeyboardArrowRight />}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PageHeading;